import { useQuery } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";

import type { ISortProps } from "app/pages/digital-marketing/ad-intelligence/common/utils/utils";
import DurationService from "app/services/DurationService";
import { DefaultFetchService } from "app/services/fetchService";
import { SourceTypeMap } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import { useTopicsEndpoints } from "../topicsEndpoints";
import type { IKeywordsResponse, ITransformedEnrichedKeywordsData } from "../types";
import { transformEnrichedKeywordsData } from "../utils";

const fetchService = DefaultFetchService.getInstance();

export const useEnrichedKeywordsData = (topicId: string, totalCount: number, sort: ISortProps) => {
    const { duration, country, webSource, key, pageFilter, selectedPageTab } = useCurrentStateAndParams().params;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const endpoints = useTopicsEndpoints();

    return useQuery<IKeywordsResponse, Error, ITransformedEnrichedKeywordsData[]>({
        queryKey: [endpoints.keywordsExpansion, topicId, totalCount, sort.sort, sort.asc, selectedPageTab],
        queryFn: async () =>
            await fetchService.get<IKeywordsResponse>(endpoints.keywordsExpansion, {
                topicId,
                country,
                webSource,
                keys: key,
                pageFilterJson: pageFilter,
                from,
                to,
                isWindow,
                sourceType: SourceTypeMap[selectedPageTab],
                page: 1,
                pageSize: totalCount,
                sort: sort.sort,
                asc: sort.asc,
            }),
        select: (data) => transformEnrichedKeywordsData(data, key),
    });
};
